import OptumTokens from '../../tokens/optum.json';
import {createUniversalTheme} from '../UniversalTheme';

const OptumDefault = createUniversalTheme(OptumTokens, 'Optum');

export {OptumDefault, OptumTokens};
